module.exports = __webpack_public_path__ + "img/ts3.d8e92da0.png";